import React, { useEffect } from 'react';
import './Alert.css';

const Alert = ({ message, type = 'info', onClose }) => {
  const getAlertStyle = () => {
    switch (type) {
      case 'success':
        return { icon: '✓' };
      case 'error':
        return { icon: '✕' };
      case 'warning':
        return { icon: '⚠' };
      case 'info':
      default:
        return { icon: 'ℹ' };
    }
  };

  const style = getAlertStyle();

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`alert alert-${type}`}>
      <div className="alert-icon">
        {style.icon}
      </div>
      <div className="alert-message">
        {message}
      </div>
      <button onClick={onClose} className="alert-close">
        ×
      </button>
    </div>
  );
};

export default Alert;